if (!customElements.get('shipping-cutoff-promo')) {
  class ShippingCutoffPromo extends HTMLElement {
    constructor() {
      super();
      this.intervalId = null;
    }

    connectedCallback() {
      const jsonEl = this.querySelector('script[type="application/json"]');
      if (!jsonEl) return;

      try {
        this.config = JSON.parse(jsonEl.textContent);
      } catch {
        return;
      }

      this.countdownEl = this.querySelector('.js-shipping-cutoff-countdown');
      if (!this.countdownEl) return;

      window.initLazyScript(this, this.init.bind(this));
    }

    disconnectedCallback() {
      if (this.intervalId) clearInterval(this.intervalId);
    }

    init() {
      this.refresh();
      this.intervalId = setInterval(() => this.refresh(), 1000);
    }

    cutoffToday(now, hour, minute) {
      const d = new Date(now);
      d.setHours(hour, minute, 0, 0);
      return d;
    }

    cutoffTomorrow(now, hour, minute) {
      const d = new Date(now);
      d.setDate(d.getDate() + 1);
      d.setHours(hour, minute, 0, 0);
      return d;
    }

    /** Próximo lunes a la hora de corte (después de `now`). */
    nextMondayCutoff(now, hour, minute) {
      const base = new Date(now);
      for (let add = 1; add <= 8; add += 1) {
        const cand = new Date(base);
        cand.setDate(base.getDate() + add);
        if (cand.getDay() === 1) {
          cand.setHours(hour, minute, 0, 0);
          return cand;
        }
      }
      return base;
    }

    formatRemaining(ms) {
      if (ms < 0) return null;
      const totalSec = Math.floor(ms / 1000);
      const h = Math.floor(totalSec / 3600);
      const m = Math.floor((totalSec % 3600) / 60);
      const s = totalSec % 60;
      return `${h}h ${m}m ${s}s`;
    }

    makeTimerStrong(text) {
      const strong = document.createElement('strong');
      strong.className = 'product-shipping-cutoff__timer font-bold';
      strong.style.color = 'rgb(var(--shipping-cutoff-accent))';
      strong.textContent = text;
      return strong;
    }

    makeDayStrong(text) {
      const strong = document.createElement('strong');
      strong.className = 'product-shipping-cutoff__day font-bold';
      strong.textContent = text;
      return strong;
    }

    /**
     * Soporta marcadores: {countdown}, {delivery_hour}, {emph_day}
     * @param {string} template
     * @param {{ countdown: string, deliveryHour: string, emphDay: string }} values
     */
    renderShippingLine(template, values) {
      const TOK_CD = '__TOK_CD__';
      const TOK_HR = '__TOK_HR__';
      const TOK_DY = '__TOK_DY__';
      let s = String(template)
        .replace(/\{countdown\}/g, TOK_CD)
        .replace(/\{delivery_hour\}/g, TOK_HR)
        .replace(/\{emph_day\}/g, TOK_DY);
      const splitRe = /(__TOK_CD__|__TOK_HR__|__TOK_DY__)/;
      const segments = s.split(splitRe).filter((seg) => seg !== '');

      this.countdownEl.textContent = '';
      segments.forEach((seg) => {
        if (seg === TOK_CD) {
          this.countdownEl.appendChild(this.makeTimerStrong(values.countdown));
        } else if (seg === TOK_HR) {
          this.countdownEl.appendChild(document.createTextNode(values.deliveryHour));
        } else if (seg === TOK_DY) {
          this.countdownEl.appendChild(this.makeDayStrong(values.emphDay));
        } else if (seg) {
          this.countdownEl.appendChild(document.createTextNode(seg));
        }
      });
    }

    refresh() {
      const now = new Date();
      const {
        cutoffHour: ch,
        cutoffMinute: cm,
        showCountdown,
        deliveryHour,
        templateToday,
        templateTomorrow,
        templateMonday,
      } = this.config;

      const hour = Number(ch);
      const minute = Number(cm);
      const cutoff = this.cutoffToday(now, hour, minute);
      const beforeCutoff = now.getTime() < cutoff.getTime();
      const day = now.getDay();

      /** @type {Date | null} */
      let countdownTarget = null;
      /** @type {'today'|'tomorrow'|'monday'} */
      let templateKind = 'today';

      if (day === 0) {
        countdownTarget = this.nextMondayCutoff(now, hour, minute);
        templateKind = 'monday';
      } else if (day === 6) {
        if (beforeCutoff) {
          countdownTarget = cutoff;
          templateKind = 'today';
        } else {
          countdownTarget = this.nextMondayCutoff(now, hour, minute);
          templateKind = 'monday';
        }
      } else if (day >= 1 && day <= 5) {
        if (beforeCutoff) {
          countdownTarget = cutoff;
          templateKind = 'today';
        } else {
          countdownTarget = this.cutoffTomorrow(now, hour, minute);
          templateKind = 'tomorrow';
        }
      }

      const countdownTemplate =
        templateKind === 'today'
          ? templateToday
          : templateKind === 'tomorrow'
            ? templateTomorrow
            : templateMonday;

      const emphDay =
        templateKind === 'today' ? 'HOY' : templateKind === 'tomorrow' ? 'MAÑANA' : 'EL LUNES';

      const remaining =
        showCountdown && countdownTarget ? countdownTarget.getTime() - now.getTime() : -1;
      const formatted = this.formatRemaining(remaining);

      const dh = deliveryHour != null && deliveryHour !== '' ? String(deliveryHour).trim() : '23';

      if (formatted && countdownTemplate && String(countdownTemplate).trim()) {
        this.countdownEl.hidden = false;
        this.renderShippingLine(countdownTemplate, {
          countdown: formatted,
          deliveryHour: dh,
          emphDay,
        });
      } else {
        this.countdownEl.hidden = true;
        this.countdownEl.textContent = '';
      }
    }
  }

  customElements.define('shipping-cutoff-promo', ShippingCutoffPromo);
}
